module.exports = __webpack_public_path__ + "static/img/tutorial-normal-attraction-4.90ea7cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-normal-attraction-4.jpg
// module id = rjy3
// module chunks = 3